import React from "react";

import {
  INSULATED_BUMPER_TYPE_OPTIONS,
  INSULATED_COOLING_UNIT_OPTIONS,
} from "../../../data";
import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import {
  AccessoryNoteCard,
  AccessoryTypeCard,
} from "./AccessoriesCards";
import AccessoriesTable from "./AccessoriesTable";
import { insulatedKey } from "./BoxStructureCards";

const AccessoriesSafety = () => (
  <>
    <StructureSection titleKey={insulatedKey("SECTIONS.SAFETY")}>
      <CardRow columns={3}>
        <AccessoryTypeCard
          cardKey="rearBumper"
          titleKey={insulatedKey("CARDS.REAR_BUMPER")}
          options={INSULATED_BUMPER_TYPE_OPTIONS}
        />
        <AccessoryNoteCard
          cardKey="rearLightMounts"
          titleKey={insulatedKey("CARDS.REAR_LIGHT_MOUNTS")}
        />
        <AccessoryNoteCard
          cardKey="hazmatSigns"
          titleKey={insulatedKey("CARDS.HAZMAT_SIGNS")}
        />
      </CardRow>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="extinguisherMount"
          titleKey={insulatedKey("CARDS.EXTINGUISHER_MOUNT")}
        />
        <AccessoryNoteCard
          cardKey="spareWheelCarrier"
          titleKey={insulatedKey("CARDS.SPARE_WHEEL_CARRIER")}
        />
        <AccessoryNoteCard
          cardKey="lashingStrips"
          titleKey={insulatedKey("CARDS.LASHING_STRIPS")}
        />
      </CardRow>
    </StructureSection>

    <AccessoriesTable />

    <StructureSection titleKey={insulatedKey("SECTIONS.VEHICLE_ADDONS")}>
      <CardRow columns={2}>
        <AccessoryNoteCard
          cardKey="wings"
          titleKey={insulatedKey("CARDS.WINGS")}
        />
        <AccessoryTypeCard
          cardKey="coolingUnit"
          titleKey={insulatedKey("CARDS.COOLING_UNIT")}
          options={INSULATED_COOLING_UNIT_OPTIONS}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesSafety;
